import { discardPendingSignInAction } from './pendingSignInAction';

export type SessionExpiryListener = () => void;

let activeListener: SessionExpiryListener | null = null;
// A signal sent while nothing listens, held until the next subscriber (the proactive refresh
// timer can fire before React mounts).
let isSignalLatched = false;

/** Ends the session everywhere: discards any stored pending sign-in action and tells the listener. */
export function signalSessionExpired(): void {
  discardPendingSignInAction();
  if (activeListener) {
    activeListener();
  } else {
    isSignalLatched = true;
  }
}

/** Registers the one listener, delivering a latched signal once; returns its unsubscribe function. */
export function subscribeToSessionExpiry(listener: SessionExpiryListener): () => void {
  activeListener = listener;
  if (isSignalLatched) {
    isSignalLatched = false;
    listener();
  }
  return () => {
    if (activeListener === listener) activeListener = null;
  };
}
